/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";

const ModeToggle = ({ mode, onChange, disabled }) => {
  return (
    <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
      <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <input
          type="radio"
          checked={mode === "CHALLENGE"}
          onChange={() => onChange("CHALLENGE")}
          disabled={disabled}
        />
        Remove by Challenge
      </label>

      <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <input
          type="radio"
          checked={mode === "IDEAS"}
          onChange={() => onChange("IDEAS")}
          disabled={disabled}
        />
        Remove by Tagged Ideas
      </label>
    </div>
  );
}

export default ModeToggle